import React from "react";
import { Link } from "react-router-dom";
import { FOOTER } from "@/constants/testIds";
import { SITE } from "@/lib/site";

const SiteFooter = () => {
  const year = new Date().getFullYear();
  return (
    <footer
      data-testid={FOOTER.root}
      className="relative w-full pt-24 md:pt-32 pb-12"
    >
      <div className="absolute inset-x-0 top-0 h-px" style={{ background: "var(--soti-rule)" }} />

      <div className="max-w-5xl mx-auto px-6 md:px-12 lg:px-16">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-10">
          <div className="max-w-xl">
            <div className="flex items-center gap-3 mb-5">
              <span
                className="inline-block w-[10px] h-[10px] rotate-45"
                style={{ background: "var(--soti-cinder)" }}
                aria-hidden="true"
              />
              <span className="overline text-[#F3EFEA]">{SITE.brand}</span>
            </div>
            <p
              data-testid={FOOTER.copy}
              className="text-[#A19D99] text-sm leading-relaxed font-light"
            >
              {SITE.brand}
              <sup className="ml-[1px] text-[0.65em]">™</sup> is a fictional
              science-fantasy universe created by{" "}
              <span className="text-[#D9D4CD]">{SITE.author}</span>.
            </p>
          </div>

          <nav className="flex flex-wrap items-center gap-x-8 gap-y-4">
            <a
              data-testid={FOOTER.linkArchive}
              href={SITE.archiveUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="link-quiet text-[0.72rem] tracking-[0.22em] uppercase"
            >
              Cinder Archive
            </a>
            <a
              data-testid={FOOTER.linkContact}
              href={`mailto:${SITE.inquiriesEmail}`}
              className="link-quiet text-[0.72rem] tracking-[0.22em] uppercase"
            >
              Contact
            </a>
            <Link
              data-testid={FOOTER.linkPrivacy}
              to="/privacy-policy"
              className="link-quiet text-[0.72rem] tracking-[0.22em] uppercase"
            >
              Privacy Policy
            </Link>
            <Link
              data-testid={FOOTER.linkTerms}
              to="/terms"
              className="link-quiet text-[0.72rem] tracking-[0.22em] uppercase"
            >
              Terms
            </Link>
          </nav>
        </div>

        <div
          className="mt-16 pt-6 space-y-2 text-[#6F6B68] text-xs tracking-[0.18em] uppercase"
          style={{ borderTop: "1px solid var(--soti-rule)" }}
        >
          <p data-testid="footer-copyright">
            © {year} {SITE.author}. All rights reserved.
          </p>
          <p data-testid="footer-trademark" className="text-[#6F6B68]">
            SHADOWS OF THE INFINITE
            <sup className="ml-[1px] text-[0.7em]">™</sup> is a trademark of{" "}
            {SITE.author}. Trademark application pending.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default SiteFooter;
